"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactTippy = require("react-tippy");

var _ = require("../");

var _jsxRuntime = require("react/jsx-runtime");

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledWrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: absolute;\n  z-index: 4;\n  top: 50%;\n  right: 1rem;\n  transform: translateY(-50%);\n  cursor: default;\n  color: ", ";\n"])), function (p) {
  return p.theme.colorLabel;
});

var FormRowTooltip = function FormRowTooltip(_ref) {
  var children = _ref.children,
      _ref$trigger = _ref.trigger,
      trigger = _ref$trigger === void 0 ? "mouseenter" : _ref$trigger;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledWrapper, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactTippy.Tooltip, {
      trigger: trigger,
      title: children,
      distance: 12,
      unmountHTMLWhenHide: true,
      hideOnClick: false,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_.MatIcon, {
        children: "help_outline"
      })
    })
  });
};

var _default = FormRowTooltip;
exports.default = _default;